class SubscriptionOptions extends HTMLElement {
  constructor() {
    super();
    this.radioInputs = null;
    this.selectElement = null;
    this.submitButton = null;
    this.quickshopModal = null;
  }

  connectedCallback() {
    this.initializeElements();
    this.attachEventListeners();
    this.updateActiveRadioOption();
  }

  initializeElements() {
    // Find the closest quickshop modal
    this.quickshopModal = this.closest('.quickshop');
    
    // Find radio inputs for purchase type
    this.radioInputs = this.querySelectorAll('.subscription-widget__radio');
    
    // Find the subscription plans select
    this.selectElement = this.querySelector('.subscription-widget__select');
    
    // Find the submit button in the quickshop modal
    if (this.quickshopModal) {
      const productFormButtons = this.quickshopModal.querySelector('.product-form__buttons');
      if (productFormButtons) {
        this.submitButton = productFormButtons.querySelector('button');
      }
    }
  }

  attachEventListeners() {
    // Listen for changes on radio inputs
    if (this.radioInputs) {
      this.radioInputs.forEach(radio => {
        radio.addEventListener('change', () => {
          this.handlePurchaseTypeChange();
        });
      });
    }

    // Listen for changes on the select dropdown
    if (this.selectElement) {
      this.selectElement.addEventListener('change', () => {
        this.handleSelectChange();
      });
    }
  }

  handlePurchaseTypeChange() {
    const selectedRadio = this.querySelector('.subscription-widget__radio:checked');
    
    // Update active class on radio options
    this.updateActiveRadioOption();
    
    if (!selectedRadio) {
      this.removeSellingPlanAttribute();
      return;
    }

    const purchaseType = selectedRadio.value;

    if (purchaseType === 'onetime') {
      // Remove selling plan attribute for one-time purchase
      this.removeSellingPlanAttribute();
    } else if (purchaseType === 'subscription') {
      // Get the selected selling plan from the select
      this.updateSellingPlanFromSelect();
    }
  }

  handleSelectChange() {
    // Check if subscription radio is selected
    const subscriptionRadio = this.querySelector('.subscription-widget__radio[value="subscription"]:checked');
    
    if (subscriptionRadio) {
      // Only update if subscription is selected
      this.updateSellingPlanFromSelect();
    }
  }

  updateSellingPlanFromSelect() {
    if (!this.selectElement || !this.submitButton) {
      return;
    }

    const selectedPlanId = this.selectElement.value;

    if (selectedPlanId && selectedPlanId !== '') {
      // Add selling plan id as data attribute
      this.submitButton.setAttribute('data-selling-plan-id', selectedPlanId);
    } else {
      // Remove attribute if no plan selected
      this.removeSellingPlanAttribute();
    }
  }

  removeSellingPlanAttribute() {
    if (this.submitButton) {
      this.submitButton.removeAttribute('data-selling-plan-id');
    }
  }

  updateActiveRadioOption() {
    // Remove active class from all radio option containers
    const allRadioOptions = this.querySelectorAll('.subscription-widget__radio-option');
    allRadioOptions.forEach(option => {
      option.classList.remove('active');
    });

    // Add active class to the selected radio's parent container
    const selectedRadio = this.querySelector('.subscription-widget__radio:checked');
    if (selectedRadio) {
      const radioOption = selectedRadio.closest('.subscription-widget__radio-option');
      if (radioOption) {
        radioOption.classList.add('active');
      }
    }
  }
}

// Register the custom element
customElements.define('subscription-options', SubscriptionOptions);

